export const listActions = <const>{
	SAVE_TABLE: 'saveTable',
};
